import './framework.js';

(function ($, bodyScrollLock) {

    function setNavigation() {
        $('#navigation > .nav').find('.toggle-dropdown').remove();
        // $('#menu-main-menu > .nav-item').find('.menu-item-has-children').each(function () {
        //     if ($(this).find('> .toggle-dropdown').length == 0) {
        //         $('<span class="toggle-dropdown"></span>').insertAfter($(this).find('> a'));
        //     }
        // });

        $('#menu-main-menu .current-menu-item').each(function () {
            if ($(this).find('.dropdown-item').hasClass('active')) {
                $(this).find('.plus-icon').addClass('active');
            }
        });

        $('#navigation > .nav .toggle-dropdown').off('click');
        $('#navigation > .nav .toggle-dropdown').click(function (e) {
            e.preventDefault();
            $(this).parent('li').toggleClass('show');
            $(this).parent('li').find('> .dropdown-menu').toggleClass('show');
            return false;
        });

        $('#navigation > .nav .nav-link-dd').off('click');
        $('#navigation > .nav .nav-link-dd').click(function (e) {
            window.location.href = $(this).attr('href');
        });

        $('#navigation > .nav .dropdown-item').off('click');
        $('#navigation > .nav .dropdown-item').click(function (e) {
            window.location.href = $(this).attr('href');
        });

        // if(window.viewMode != 'desktop'){
        //     $('#navigation > .toggle-dropdown').off('click');
        //     $('#navigation > .toggle-dropdown').on('click', function (e) {
        //         e.preventDefault();
        //         $(this).parent('li').toggleClass('show');
        //         $(this).parent('li').find('> .dropdown-menu').toggleClass('show');
        //     });
        // } else {
        //     $('#navigation > .nav .nav-link-dd').off('click');
        // }
    }

    function setStickyFooter() {
        var windowHeight = parseInt($(window).height());
        var headerHeight = parseInt($('#header').outerHeight(true));
        var contentHeight = parseInt($('#content-wrapper').outerHeight(true));
        var footerHeight = parseInt($('#footer').outerHeight(true));

        var restHeight = windowHeight - headerHeight - contentHeight;

        if (restHeight >= footerHeight) {
            $('#footer').addClass('sticky');
        } else {
            $('#footer').removeClass('sticky');
        }
    }

    function setIconBoxes() {
        $('.subpages').find('.subpage-box .subpage-icon').height('auto');
        $('.subpages').find('.subpage-box .subpage-title').height('auto');
        $('.subpages').find('.subpage-box .subpage-description').height('auto');

        $('.subpages').each(function () {
            var $columns1 = $('.subpage-box .subpage-icon', this);
            var maxHeight1 = Math.max.apply(Math, $columns1.map(function () {
                return $(this).innerHeight();
            }).get());
            $columns1.css('height', maxHeight1 + 'px');

            var $columns2 = $('.subpage-box .subpage-title', this);
            var maxHeight2 = Math.max.apply(Math, $columns2.map(function () {
                return $(this).innerHeight();
            }).get());
            $columns2.css('height', maxHeight2 + 'px');

            var $columns3 = $('.subpage-box .subpage-description', this);
            var maxHeight3 = Math.max.apply(Math, $columns3.map(function () {
                return $(this).innerHeight();
            }).get());
            $columns3.css('height', maxHeight3 + 'px');
        });
    }


    function initSlickSlider() {
        $('.stage-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 5000,
        });

        let isChanging = false;
        const homeSliderSettings = {
            infinite: true,
            dots: true,
            adaptiveHeight: false,
            autoplay: false,
            autoplaySpeed: 5000,
            slidesPerRow: 2,
            rows: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        slidesPerRow: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        slidesPerRow: 1,
                    },
                },
                {
                    breakpoint: 421,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        slidesPerRow: 1,
                    },
                },
            ],
        };

        const $homeDesktopSlider = $('.home-slider.desktop-only');
        const $homeMobileSlider = $('.home-slider.mobile-only');

        $(window).on('load resize orientationchange', function () {
            // $homeSlider.removeClass("slick-initialized slick-slider");
            if (!isChanging) {
                // $('#breakpointValue').text( String(slick.activeBreakpoint) );
                // Prevent infinite loop
                isChanging = true;
                // The highest breakpoint is null
                if ($(window).width() <= 992) {
                    if (!($homeMobileSlider.hasClass('slick-initialized'))) {
                        //console.log(slick);
                        //slick.slickUnfilter();
                        // isFiltered = true;
                        $homeMobileSlider.not('.slick-initialized').slick(homeSliderSettings).slick('slickFilter', ':even');
                        $homeDesktopSlider.removeClass('slick-initialized slick-slider');
                        // if ($homeDesktopSlider.hasClass('slick-initialized')){
                        //     $homeDesktopSlider.slick('unslick');
                        // }
                        // isSlickDestroyed = false;
                    }
                } else {
                    // $homeSlider.slick('slickUnfilter');
                    // slick.refresh();
                    if (!($homeDesktopSlider.hasClass('slick-initialized'))) {
                        //$homeMobileSlider.slick('unslick');
                        $homeDesktopSlider.not('.slick-initialized').slick(homeSliderSettings);
                        $homeMobileSlider.removeClass('slick-initialized slick-slider');
                        //$homeSlider.slick('unslick').slick(homeSliderSettings);
                        // setTimeout(function(){
                        //     $homeSlider.slick(homeSliderSettings);
                        // }, 100);
                        // slick.removeClass("slick-initialized slick-slider");
                        // slick.slick(homeSliderSettings);
                        // $homeSlider.removeClass("slick-initialized slick-slider");
                    }
                }
                isChanging = false;
            }
        });

        //Fix bug in firefox
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            setTimeout(() => {
                $(window).trigger('resize');
            }, 500);
        }

        $('.download_list .row').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 421,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    function initResponsiveTools() {
        setIconBoxes();
        setStickyFooter();
    }

    function adjustMorebutton() {
        var getAjaxEleHeight = $('#ajaxContent').height();
    }

    $(document).ready(function () {

        let page = null;
        let filteredTaxonomyList = [];
        let getDataInterestsSlug = null;
        let getDataTaxonomyType = null;
        let selectedTaxonomySlug = null;

        $('.external:not(.subpage-box),  a[href^=\'http://\']:not(.subpage-box),  a[href^=\'https://\']:not(.subpage-box)').click(function (e) {
            e.preventDefault();

            var a = new RegExp('/' + window.location.host + '/');
            if (!a.test(this.href)) {
                if (!$(this).hasClass('no-popup')) {
                    var href = $(this).attr('href');
                    $('#modal-exit').modal('show');
                    $('#modal-exit').find('.confirm').click(function (e) {
                        $(this).off();
                        window.open(
                            href,
                            '_blank',
                        );
                    });
                } else {
                    var href = $(this).attr('href');
                    window.open(
                        href,
                        '_blank',
                    );
                }
            } else {
                window.location.href = $(this).attr('href');
            }
        });

        $('a[href]:not([data-global-external-link-modal-confirm]):not(".no_popup")').on('click', function (event) {

            var hrefUrl = $(this).attr('href');
            if (typeof hrefUrl !== 'undefined' && hrefUrl !== false && hrefUrl != "#" && false == hrefUrl.startsWith("mailto:")) {
                console.log(hrefUrl);
                console.log(!hrefUrl.includes('gileadpro.de'));
                if (!hrefUrl.includes('gilead.com') && !hrefUrl.includes('gileadsciences.de') && !hrefUrl.includes('askgileadmedical.com') && !this?.classList?.contains('force-external-link')) {
                    var a = document.createElement('a');
                    a.href = hrefUrl;
                    if (a.hostname !== window.location.hostname) {
                        event.preventDefault();
                        $('.global-external-link-modal').show();
                        $('[data-global-external-link-modal-confirm]').attr('href', hrefUrl);
                    }
                } else {
                    window.open(hrefUrl, '_blank').focus();
                }
            }
        });
        $('[data-global-external-link-modal-cancel]').on('click', function () {
            $('.global-external-link-modal').hide();
            $('[data-global-external-link-modal-confirm]').attr('href', '#');
        });
        $('[data-global-external-link-modal-confirm]').on('click', function () {
            $('.global-external-link-modal').hide();
        });

        $('.accordion').on('hidden.bs.collapse', function () {
            $('html,body').animate({
                scrollTop: $(this).find('.collapsed').offset().top - 300,
            }, 500);
        });

        $('.accordion .card-header[data-toggle="collapse"], .accordion-down-arrow').on('click', function () {
            if ($(this).parent('.card').find('.mb-0').hasClass('content-collapsed')) {
                $(this).parent('.card').find('.mb-0').removeClass('content-collapsed');
            } else {
                if ($(this).is('#accordion-heading--1')) {
                    $('.accordion').on('hidden.bs.collapse', function (e) {
                        $(this).find('.mb-0').not($(e.target)).removeClass('content-collapsed');
                    });
                }
                $(this).parent('.card').find('.mb-0').addClass('content-collapsed');
            }
        });

        $('.post-item .teaser-image').on('click', function () {
            var href = $(this).attr('href');
            console.log(href);
            console.log(e.metaKey);
            if (e.metaKey) {
                open(href, '_blank')
            } else {
                location.href = href
            }
        });


        $('#toggle-navigation').click(function (e) {
            e.preventDefault();
            var targetElement = document.querySelector("#content-wrapper");
            var menuElement = document.querySelector(".mobile-menu-sliding-block");

            // Close all Level-0 menus before opening this one
            $('.menu-item-has-children.nav-item.dropdown.level-0 .plus-icon').removeClass('active');
            $('.menu-item-has-children.nav-item.dropdown.level-0 .sliding-menu').slideUp();

            $('body').toggleClass('show-navigation');
            if ($('body').hasClass('show-navigation')) {
                setNavigation();
                $('#menu-main-menu, .mobile-menu-sliding-block').removeClass('d-none');
                // $('.navigation-overlay').fadeIn(500);

                // Allow scrolling only inside `.mobile-menu-sliding-block`
               // bodyScrollLock.disableBodyScroll(menuElement);
                //debugger

                $('.sticky-block.open-content').addClass('d-none');
            } else {
                // $('.navigation-overlay').fadeOut(500);
                $('#menu-main-menu, .mobile-menu-sliding-block').addClass('d-none');
                $('.sticky-block.open-content').removeClass('d-none');

                // Re-enable body scroll when menu is closed
              //  bodyScrollLock.enableBodyScroll(menuElement);
                $('.menu-item-has-children.nav-item .dropdown-item').removeClass('active');
            }
        });

        //let debounce = null;
        // $('.menu-item-has-children.nav-item.dropdown.level-0').mouseenter(function(){
        //     console.log('here');
        //     //clearTimeout(debounce);
        //     // debounce = setTimeout(function(){
        //     //     $(this).find('.sliding-menu').css('display', 'block');
        //     // }, 100);
        //     debounce(()=> {
        //         $(this).find('.sliding-menu').css('display', 'block');
        //     }, 300);
        // }).mouseleave(function(){
        //     // clearTimeout(debounce);
        //     // debounce = setTimeout(function(){
        //     //     $(this).find('.sliding-menu').css('display', 'none');
        //     // }, 100);
        //     debounce(()=> {
        //         $(this).find('.sliding-menu').css('display', 'none');
        //     }, 300);
        // });

        if ($(window).width() > 1273) {

            $('.menu-item-has-children.nav-item.dropdown.level-0').mouseenter(function () {
                if ($(window).width() > 1273) {
                    $(this).find('.sliding-menu').css('display', 'block');
                } else {
                    $(this).find('.sliding-menu').first().css('display', 'block');
                }
            }).mouseleave(function () {
                if ($(window).width() > 1273) {
                    $(this).find('.sliding-menu').css('display', 'none');
                } else {
                    $(this).find('.sliding-menu').first().css('display', 'none');
                }
            });
        }
        //
        //
        // $('.menu-item-has-children.nav-item.dropdown .plus-icon').on('click touchend', function(){
        //     $('.menu-item-has-children.nav-item.dropdown .plus-icon').removeClass('active');
        //     $(this).toggleClass('active');
        //     $(this).parent('.level-0').find('.depth-0').toggleClass('add-border');
        // });
        //
        // $('.menu-item-has-children.nav-item.dropdown.level-1 .toggle-dropdown').on('click', function(){
        //     $(this).toggleClass('active');
        // });

        // Toggle Level-0 menu on clicking plus-icon
        $(document).on('click', '.menu-item-has-children.nav-item.dropdown.level-0 > .plus-icon', function (e) {
            e.stopPropagation(); // Prevent bubbling

            console.log('Came here');  // Log check to confirm click event
            console.log('Clicked Level-0:', $(this).hasClass('active'));

            let parentMenu = $(this).closest('.menu-item-has-children');  // Get the closest <li>
            let submenu = parentMenu.children('.sliding-menu');  // Get only its submenu

            // Check if this Level-0 is already active
            let isActive = $(this).hasClass('active');

            // Close all Level-0 menus before opening this one
            $('.menu-item-has-children.nav-item.dropdown.level-0 .plus-icon').removeClass('active');
            $('.menu-item-has-children.nav-item.dropdown.level-0 .sliding-menu').slideUp();

            // If it wasn't active before, open it again
            if (!isActive) {
                $(this).addClass('active');
                submenu.stop(true, true).slideDown();
            }
        });

        // Toggle Level-1 submenu using event delegation
        $(document).on('click', '.menu-item-has-children.nav-item.dropdown.level-1 > .plus-icon', function (e) {
            e.stopPropagation(); // Prevent bubbling

            console.log('Came here - Level 1');  // Log check for Level-1 clicks
            console.log('Clicked Level-1:', $(this).hasClass('active'));

            let parentMenu = $(this).closest('.menu-item-has-children');  // Get the closest Level-1 <li>
            let submenu = parentMenu.children('.sliding-menu');  // Get its submenu

            // Check if this Level-1 is already active
            let isActive = $(this).hasClass('active');

            // Close all other Level-1 submenus before opening this one
            $('.menu-item-has-children.nav-item.dropdown.level-1 .plus-icon').removeClass('active');
            $('.menu-item-has-children.nav-item.dropdown.level-1 .sliding-menu').slideUp();

            // If it wasn't active before, open it again
            if (!isActive) {
                $(this).addClass('active');
                submenu.stop(true, true).slideDown();
            }
        });


        $('.toggle-search-desktop').click(function (e) {
            e.preventDefault();
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $('#search-desktop').fadeOut(300);
            } else {
                $(this).addClass('open');
                $('#search-desktop').fadeIn(300);
            }
        });

        $('[data-href]').on('click', function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var target = $(this).data('target');

            if (target != '' && typeof target != 'undefined') {
                window.open(url, target);
            } else {
                window.location.replace(url);
            }
        });

        $('[data-toggle="popover"]').popover({
            html: true,
            sanitize: false,
            placement: 'top',
            container: "body",
            trigger: 'click',
        });

        $(document).on("click", ".popover .popover-header", function () {
            $(this).parents(".popover").popover('hide');
        });


        // TABS link in navigation
        function scrollTo() {
            var offset = $('#header').outerHeight() + 50;
            $('html, body').animate({
                scrollTop: $('.downloads_filter').offset().top - offset,
            }, 500);
        }

        $('.timeline a.nav-link').on('show.bs.tab', function (event) {
            $('a.nav-link').removeClass('active');
            var id = $(this).attr('href');
            $("a[href*='" + id + "']").addClass('active');
            history.replaceState(undefined, undefined, id);
            scrollTo();
        });

        window.addEventListener('hashchange', function () {
            var anchor = window.location.hash.substring(1);
            $("a[href='#" + anchor + "']").trigger('click');
        }, false);

        $('.tab-content').on('click', 'button', function () {
            $(this).toggleClass('active');
            $grid.isotope({ filter: concatValues(createFilter()) });
        });


        function concatValues(obj) {
            var value = '';
            for (var prop in obj) {
                value += obj[prop] + ',';
            }
            return value.slice(0, -1);
        }

        $('.down-arrow').on('click', function () {
            $(this).toggleClass('hide');
            $(this).parent().parent('.flex-row').children('.right-block').toggleClass('active');
            $('.up-arrow').removeClass('hide');
            $(this).parent().parent('.flex-row').children().find('.up-arrow').removeClass('hide');
        });

        $('.up-arrow').on('click', function () {
            $(this).parent().parent('.flex-row').children().find('.down-arrow').removeClass('hide');
            $(this).addClass('hide');
            $(this).parent().parent('.flex-row').children('.right-block').toggleClass('active');
        });

        function getDataTaxonomyVal() {
            if (!$('body').hasClass('home')) {
                getDataInterestsSlug = $('.filter-container').data('interests-slug');
                getDataTaxonomyType = $('.filter-container').data('taxonomy-type');
            }
        }

        function getSelectedInterestTaxonomySlug() {
            if (!$('body').hasClass('home')) {
                selectedTaxonomySlug = $('.filter-container').data('interests-slug');
                console.log($('.filter-container').attr('data-taxonomy-type'));
                if ($('.filter-container').attr('data-taxonomy-type') === undefined) {
                    filteredTaxonomyList = [{
                        name: 'interests',
                        value: selectedTaxonomySlug
                    }];
                }
            }
        }

        function setPageNumber() {
            if (getDataInterestsSlug && getDataInterestsSlug === 'pdf') {
                page = 3;
            } else {
                page = 2;
            }
        }

        // end download filter

        function postsFilterActions() {

            $('.load-more').click(function () {
                $_this = $(this);

                var orderBy = $('ul.sort-list > li.active').data('order');
                var element = document.querySelector('ul.category-list > li .active');

                var data = {
                    'action': 'filter_posts_by_category',
                    'filterTaxonomyPosts': getDataTaxonomyType,
                    'filterTaxonomySlug': getDataInterestsSlug,
                    'taxonomy': 'interests',
                    'taxonomySlug': filteredTaxonomyList,
                    'orderBy': (orderBy === undefined) ? 'meta_value' : orderBy,
                    'category': (typeof element != 'undefined') ? $(element).attr('value') : '',
                    'page': ++page,
                    'postsPerPage': 2,
                    'postId': postId,
                };

                console.log(getDataTaxonomyType);
                console.log(data);

                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'json',
                    data: data,
                    beforeSend: function () {
                        // $('#ajaxContent').find( '.download-item' ).remove();
                        $(document).scrollTop();
                        $('#ajaxContent').append('<div class="spinner-border" role="status">\n' +
                            '  <span class="sr-only">Loading...</span>\n' +
                            '</div>');
                    },
                    success: function (res) {
                        if (res) {
                            $('#ajaxContent .spinner-border').remove();
                            if (res.length === 0) {
                                page = 2;
                                $('.load-more').hide();
                                $('.load-less').removeClass('active');
                                $('.load-less').addClass('hide');
                                $('.filter-container').append(res.html);
                            } else {
                                $('#ajaxContent').append(res.html);
                            }
                        }

                        console.log($('#ajaxContent').children().length);
                        console.log(res);
                        console.log(res.totalPosts);

                        if ($('#ajaxContent').children().length - 1 === res.totalPosts) {
                            $_this.hide();
                            setPageNumber();
                            $('.load-less').removeClass('hide');
                            $('.load-less').addClass('active');
                        }

                        if ($('#ajaxContent').children().length === totalCount) {
                            $_this.hide();
                            setPageNumber();
                            $('.load-less').removeClass('hide');
                            $('.load-less').addClass('active');
                        }
                    },
                    error: function (request, status, error) {
                        console.log(request);
                        console.log(status);
                        console.log(error);
                    },
                });
            });

            $('.category-link').on('click', function () {
                $('.category-link').removeAttr('checked');
                $(this).checked = true;
                $('.category-link').removeClass('active');
                $(this).addClass('active');
                $('.load-less').removeClass('active');
                $('.load-less').addClass('hide');

                $('.load-more').show();

                $('#all').prop('checked', false);

                var orderBy = $('ul.sort-list > li.active').data('order');

                if ($('.filter-container .no-results').length) {
                    $('.filter-container .no-results').remove();
                }


                var args = {
                    action: 'filter_posts_by_category',
                    orderBy: (orderBy === undefined) ? 'meta_value' : orderBy,
                    category: ($(this).attr('value') !== '') ? $(this).attr('value') : '',
                    post_id: postId,
                };

                var element = document.querySelector('ul.taxonomies-list > li .active');

                if ($('.filter-container').data('taxonomy-type') !== 'article_types') {
                    var taxonomyVal = (getDataInterestsSlug === 'pdf') ? 'medium' : 'interests';
                }

                if ((typeof element != 'undefined')) {
                    if ($(element).attr('value') !== '') {
                        args['filterTaxonomyPosts'] = getDataTaxonomyType;
                        args['filterTaxonomySlug'] = getDataInterestsSlug;
                        args['taxonomy'] = taxonomyVal;
                        args['taxonomySlug'] = filteredTaxonomyList;
                    }
                }

                if ($('.filter-container').data('taxonomy-type') === 'article_types') {
                    args['filterTaxonomyPosts'] = getDataTaxonomyType;
                    args['filterTaxonomySlug'] = getDataInterestsSlug;
                    args['taxonomy'] = $(element).attr('name');
                    args['taxonomySlug'] = filteredTaxonomyList;
                }

                filterPostsByAjax(args);
            });

            $('.filter-posts').on('click', function () {

                var nameAttr = $(this).attr('name');
                var dataTaxonomyAttr = $(this).data('taxonomy');

                $('.load-less').removeClass('active');
                $('.load-less').addClass('hide');

                $('.load-more').show();
                //  getDataTaxonomyVal();

                $('.filter-posts').removeClass('active');
                $(this).addClass('active');

                $('#all').prop('checked', false);

                if ($('.filter-container .no-results').length) {
                    $('.filter-container .no-results').remove();
                }

                if (dataTaxonomyAttr === 'interests') {
                    if (nameAttr === 'interests') {
                        // filteredTaxonomyList = [];
                        $('input[type="radio"][data-taxonomy="interests"][name!="interests"]').prop("checked", false);
                        $('.load-less').addClass('hide');
                    } else {
                        if ($('input[type="radio"][name="interests"]').prop('checked')) {
                            $('input[type="radio"][name="interests"]').prop("checked", false);
                        }
                    }
                } else {
                    if (nameAttr === 'medium') {
                        // filteredTaxonomyList = [];
                        $('input[type="radio"][data-taxonomy="medium"][name!="medium"]').prop("checked", false);
                        $('.load-less').addClass('hide');
                    } else {
                        if ($('input[type="radio"][name="medium"]').prop('checked')) {
                            $('input[type="radio"][name="medium"]').prop("checked", false);
                        }
                    }
                }

                if (filteredTaxonomyList && filteredTaxonomyList instanceof Array && filteredTaxonomyList.indexOf($(this).attr('value')) === -1) {
                    filteredTaxonomyList = filteredTaxonomyList.filter(function (item) {
                        return item !== '';
                    });
                    filteredTaxonomyList.push(
                        {
                            value: $(this).attr('value'),
                            name: $(this).attr('name'),
                        },
                    );
                } else {
                    var getItemIndex = filteredTaxonomyList.indexOf($(this).attr('value'));
                    if (getItemIndex > -1) {
                        filteredTaxonomyList.splice(getItemIndex, 1);
                    }
                    $(this).prop('checked', false);
                    if (filteredTaxonomyList.length === 0) {
                        $('input[type="radio"][name="interests"]').prop("checked", true);
                    }
                }

                filteredTaxonomyList = filterLatestValues(filteredTaxonomyList);

                var element = document.querySelector('ul.category-list > li .active');
                var orderBy = $('ul.sort-list > li.active').data('order');

                var args = {
                    action: 'filter_posts_by_category',
                    filterTaxonomyPosts: getDataTaxonomyType,
                    filterTaxonomySlug: getDataInterestsSlug,
                    taxonomySlug: filteredTaxonomyList,
                    orderBy: (orderBy === undefined) ? 'meta_value' : orderBy,
                    category: (typeof element != 'undefined') ? $(element).attr('value') : '',
                    post_id: postId
                };

                if (getDataInterestsSlug === null) {
                    args.taxonomy = 'interests';
                }

                filterPostsByAjax(args);
            });

            $('.sort-item').on('click', function () {
                var orderBy = 'meta_value';
                $('.load-more').show();

                $('.load-less').removeClass('active');
                $('.load-less').addClass('hide');

                if ($('.filter-container .no-results').length) {
                    $('.filter-container .no-results').remove();
                }

                if ($(this).hasClass('active')) {
                    if ($(this).data('order') === 'date') {
                        return;
                    }
                    $('.sort-item').removeClass('active');
                } else {
                    $('.sort-item').removeClass('active');
                    $(this).addClass('active');
                    orderBy = $(this).data('order');
                }

                var selectedCategory = document.querySelector('ul.category-list > li .active');
                var args = {
                    action: 'filter_posts_by_category',
                    orderBy: orderBy,
                    category: (typeof selectedCategory != 'undefined') ? $(selectedCategory).attr('value') : '',
                    filterTaxonomyPosts: getDataTaxonomyType,
                    filterTaxonomySlug: getDataInterestsSlug,
                    taxonomy: (getDataTaxonomyType !== undefined && getDataTaxonomyType !== null) ? getDataTaxonomyType : 'interests',
                    taxonomySlug: filteredTaxonomyList,
                    post_id: postId,
                };

                filterPostsByAjax(args);
            });

            $('.reset-filters, .load-less').on('click', function () {
                $('.category-link').removeClass('active');
                $('#all-categories').prop('checked', true);
                $('.filter-posts').removeClass('active');
                $('#all-interests').prop('checked', true);
                $('#all-medium').prop('checked', true);
                $('.load-more').show();
                $(this).prop('checked', false);

                if ($('.filter-container .no-results').length) {
                    $('.filter-container .no-results').remove();
                }

                $('input[type="radio"][data-taxonomy="interests"][name!="interests"]').prop("checked", false);
                $('input[type="radio"][data-taxonomy="medium"][name!="medium"]').prop("checked", false);

                var args = {
                    action: 'filter_posts_by_category',
                    category: '',
                };

                filteredTaxonomyList = [];

                if (selectedTaxonomySlug && selectedTaxonomySlug !== '') {
                    args.taxonomy = 'interests';
                    args.taxonomySlug = filteredTaxonomyList;
                } else {
                    args.taxonomy = 'interests';
                }

                if (getDataInterestsSlug && getDataInterestsSlug !== '') {
                    if (getDataTaxonomyType !== 'article_types') {
                        args.taxonomySlug = [{
                            name: 'interests',
                            value: getDataInterestsSlug
                        }];
                    }
                    args.taxonomy = 'interests';
                    args.filterTaxonomyPosts = getDataTaxonomyType;
                    args.filterTaxonomySlug = getDataInterestsSlug;
                }

                args.post_id = postId;

                page = 2;
                scrollTo();
                $('.load-less').removeClass('active');
                $('.load-less').addClass('hide');

                console.log(args);

                filterPostsByAjax(args);
            });
        }

        function filterLatestValues(array) {
            return array.reduce((acc, currentValue) => {
                // Check if the current name already exists in the accumulator
                const existingItemIndex = acc.findIndex(item => item.name === currentValue.name);

                // If the name already exists, replace it with the current value
                if (existingItemIndex !== -1) {
                    acc[existingItemIndex] = currentValue;
                } else {
                    // Otherwise, add the current value to the accumulator
                    acc.push(currentValue);
                }

                return acc;
            }, []).filter(item => item.value.trim() !== '');
        }

        function filterPostsByAjax(data) {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: data,
                beforeSend: function () {
                    $('#ajaxContent').find('.download-item').remove();
                    $(document).scrollTop();
                    $('#ajaxContent').append('<div class="spinner-border" role="status">\n' +
                        '  <span class="sr-only">Loading...</span>\n' +
                        '</div>');
                },
                success: function (res) {
                    if (res) {
                        if (res.length === 1) {
                            $('.load-more').hide();
                        }
                        if (res.length === 0) {
                            page = 2;
                            $('.load-more').hide();
                            $('.load-less').removeClass('active');
                            $('.load-less').addClass('hide');
                        }
                        $('#ajaxContent .spinner-border').remove();
                        $('#ajaxContent').html(res.html);

                        if ($('#ajaxContent').children().length === res.totalPosts) {
                            $('.load-more').hide();
                            setPageNumber();
                        }
                    }
                },
                error: function (request, status, error) {
                    console.log(request);
                    console.log(status);
                    console.log(error);
                },
            })
        }

        function current_rating() {
            $('.masonry-gallery').masonry({
                itemSelector: '.grid-item',
            })
        }

        function loadMoreText() {
            $('.load-btn').click(function (event) {
                $('.more-block-content').toggleClass('d-none');

                if ($(this).children(':last').html() === 'weniger lesen') {
                    $('html,body').animate({
                        scrollTop: $(this).parent().offset().top - 150,
                    }, 'slow');
                }

                if ($('.more-block-content').hasClass('d-none')) {
                    $(this).children(":first").removeClass('minus-icon').addClass('plus-icon');
                    $(this).children(":last-child").text('mehr lesen');
                } else {
                    $(this).children(':first').removeClass('plus-icon').addClass('minus-icon');
                    $(this).children(':last').text('weniger lesen');
                }
            });
        }

        function toggleStickyContent() {
            $('.sticky-toggle-arrow').click(function (event) {
                var stickyBlock = $('.sticky-block');
                var stickyImageBlock = $('.sticky-image-block');
                // stickyBlock.find('.sticky-content-block').toggleClass('d-none');
                //stickyBlock.find('.sticky-image-block').toggleClass('d-none');
                if (!stickyBlock.hasClass('open-content')) {
                    stickyBlock.addClass('open-content');
                    stickyBlock.removeClass('close-sticky-content');
                    stickyBlock.find('.sticky-content-block').removeClass('d-none');
                    stickyImageBlock.find('.sticky-title').addClass('d-none');
                    stickyImageBlock.find('.sticky-toggle-arrow').addClass('d-none');
                } else {
                    stickyBlock.removeClass('open-content');
                    stickyBlock.addClass('close-sticky-content');
                    stickyBlock.find('.sticky-content-block').addClass('d-none');
                    stickyImageBlock.find('.sticky-title').removeClass('d-none');
                    stickyImageBlock.find('.sticky-toggle-arrow').removeClass('d-none');
                    localStorage.setItem('closeStickyContent', 'closed');
                }
            });
        }

        function checkAndLoadStickyContent() {
            var stickyBlock = $('.sticky-block');
            var stickyImageBlock = $('.sticky-image-block');
            var stickyButtonClosed = localStorage.getItem('closeStickyContent');
            if (stickyButtonClosed === 'closed') {
                stickyBlock.removeClass('open-content');
                stickyBlock.addClass('close-sticky-content');
                stickyBlock.find('.sticky-content-block').addClass('d-none');
                stickyImageBlock.find('.sticky-title').removeClass('d-none');
                stickyImageBlock.find('.sticky-toggle-arrow').removeClass('d-none');
            } else {
                stickyBlock.addClass('open-content');
                stickyBlock.removeClass('close-sticky-content');
                stickyBlock.find('.sticky-content-block').removeClass('d-none');
                stickyImageBlock.find('.sticky-title').addClass('d-none');
                stickyImageBlock.find('.sticky-toggle-arrow').addClass('d-none');
            }
        }

        function updateDocCheckFrameSize(windowWidth) {
            var docCheckFrameSize = 's_red';

            if (windowWidth > 799) {

                docCheckFrameSize = 'xl_red';

            } else if (windowWidth > 639) {

                docCheckFrameSize = 'l_red';

            } else if (windowWidth > 479) {

                docCheckFrameSize = 'm_red';

            }

            $docCheckFrame.prop(
                'src',
                'https://login.doccheck.com/code/de/2000000012523/' + docCheckFrameSize + '/');

        }

        function debounce(func, delay) {
            let timeoutId;
            return function () {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(func, delay);
            };
        }

        // function displaySubmenuOnDebounce() {
        //
        // }
        // const menuItems = document.querySelectorAll('.menu-item-has-children.nav-item.dropdown.level-0');
        // menuItems.forEach((menuItem)=>{
        //     const submenu = menuItem.querySelector('.sliding-menu');
        //     console.log(menuItem);
        //     if (submenu) {
        //         menuItem.addEventListener('mouseenter', debounce(()=>{
        //             $(this).find('.sliding-menu').css('display', 'block');
        //         }, 300)); // Adjust the delay as needed (300ms in this example)
        //
        //         menuItem.addEventListener('mouseleave', debounce(()=>{
        //             $(this).find('.sliding-menu').css('display', 'none');
        //         }, 300)); // Adjust the delay as needed (300ms in this example)
        //     }
        // });

        initSlickSlider();
        adjustMorebutton();
        current_rating();
        postsFilterActions();
        loadMoreText();
        toggleStickyContent();
        checkAndLoadStickyContent();
        setPageNumber();
        getDataTaxonomyVal();
        getSelectedInterestTaxonomySlug();
        // displaySubmenuOnDebounce();
    });

    $(document).scroll(function () {

        var breadcrumbsId = document.getElementById("breadcrumbs");

        var toggleBreadCrumb = function () {
            var verticalScrollPos = window.scrollY;
            if (verticalScrollPos >= 100) {
                breadcrumbsId.className = "breadcrumbs show"
            } else {
                breadcrumbsId.className = "breadcrumbs hide"
            }
        };

        window.addEventListener("scroll", toggleBreadCrumb);
    });


})(jQuery, bodyScrollLock);
